import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="multiple-tab-opener"
export default class extends Controller {
  static targets = ["button", "calllogstarttime"]
  connect() {
  }

  open() {
    if (this.buttonTarget.dataset.urls.length > 0) {
      this.buttonTarget.dataset.urls.split(",").forEach(url => {    
        url = url + "%3Fcall_log_start_time%3D" +this.calllogstarttimeTarget.innerText
        window.open(url, '_blank')
      })
    }
  }
}
